import { render, staticRenderFns } from "./GatGroup.vue?vue&type=template&id=1c551bfc&scoped=true"
import script from "./GatGroup.vue?vue&type=script&lang=js"
export * from "./GatGroup.vue?vue&type=script&lang=js"
import style0 from "./GatGroup.vue?vue&type=style&index=0&id=1c551bfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c551bfc",
  null
  
)

export default component.exports